import { z } from 'zod';

export const EnrichedLedgerEntrySchema = z.object({
  id: z.number(),
  type: z.enum(['credit', 'debit']),
  amount: z.number(),
  transactionAt: z.string(),
  transactionType: z.string(),
  transactionId: z.string(),
  balance: z.number(),
  previousBalance: z.number(),
  displayLabel: z.string(),
  seriesTitle: z.string().optional(),
  metaData: z.record(z.string(), z.unknown()).optional(),
});

export type EnrichedLedgerEntry = z.infer<typeof EnrichedLedgerEntrySchema>;
